import { Link } from 'react-router-dom';
import JaLayout from '@/components/feature/JaLayout';
import useSEO from '@/hooks/useSEO';

export default function JaContactPage() {
  useSEO({
    title: 'お問い合わせ｜康永生技｜OEM ODM健康食品製造',
    description: '康永生技へのお問い合わせ：フォーム・電話（+886-4-2202-9858）・メール・LINE（@126uwznp）でお気軽にご連絡ください。1営業日以内にご返答します。',
    keywords: '康永お問い合わせ,OEM ODM問い合わせ,健康食品お問い合わせ,サプリメント製造台湾,康永電話,康永LINE',
    lang: 'ja',
    canonicalPath: '/ja/contact',
  });

  return (
    <JaLayout>
      <section className="relative pt-24 pb-16 bg-[#1a2e1a]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-4 text-white/60 text-[0.8125rem]">
            <Link to="/ja" className="hover:text-white transition-colors cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/90">お問い合わせ</span>
          </div>
          <h1 className="text-white font-bold text-[2.25rem] md:text-[3rem] leading-tight mb-4 max-w-2xl">
            お問い合わせ
          </h1>
          <p className="text-white/75 text-[1.0625rem] leading-[1.8] max-w-xl">
            フォーム、電話、メール、またはLINEにてお気軽にお問い合わせください。1営業日以内にご返答します。
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              { icon: 'ri-file-edit-line', title: 'お問い合わせフォーム', desc: 'フォームにご記入いただければ、1営業日以内に担当者よりご連絡いたします。', path: '/ja/contact/form', cta: 'フォームへ' },
              { icon: 'ri-map-pin-line', title: '連絡先情報', desc: '会社住所・電話番号・メールアドレス・LINE連絡先の詳細をご確認いただけます。', path: '/ja/contact/info', cta: '詳細を見る' },
            ].map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="flex items-start gap-5 bg-[#f7faf7] rounded-2xl p-8 border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-white rounded-xl border border-green-100 flex-shrink-0 group-hover:bg-[#4CAF50] transition-colors duration-300">
                  <i className={`${item.icon} text-[#4CAF50] text-2xl group-hover:text-white transition-colors duration-300`} />
                </div>
                <div>
                  <h3 className="text-[#1a2e1a] font-bold text-[1.125rem] mb-2">{item.title}</h3>
                  <p className="text-gray-500 text-[0.9375rem] leading-[1.7] mb-3">{item.desc}</p>
                  <span className="inline-flex items-center gap-1 text-[#4CAF50] text-[0.875rem] font-medium">
                    {item.cta} <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-10 bg-[#e8f5e9] border border-[#c8e6c9] rounded-2xl p-8 flex flex-col sm:flex-row items-center gap-6">
            <div className="flex items-center gap-4 flex-1">
              <div className="w-14 h-14 flex items-center justify-center bg-[#4CAF50] rounded-full flex-shrink-0">
                <i className="ri-line-fill text-white text-2xl" />
              </div>
              <div>
                <p className="text-[#1a2e1a] font-bold text-[1.125rem] mb-1">LINEでチャット相談</p>
                <p className="text-gray-600 text-[0.9375rem]">LINE@：@126uwznp — 日本語でのお問い合わせを歓迎します。</p>
              </div>
            </div>
            <a
              href="https://lin.ee/X7Hcpf4"
              rel="nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1rem] px-8 py-3.5 rounded-full transition-all duration-300 cursor-pointer flex-shrink-0"
            >
              <i className="ri-line-fill" /> LINEに追加
            </a>
          </div>
        </div>
      </section>
    </JaLayout>
  );
}
